import React from 'react'
import { useTranslation } from 'react-i18next'

export const TransactionTooltipContent: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className={'grid grid-flex gap-m'}>
      <div className={'grid-item'}>
        <span className={`font-body-medium-bold`}>{t('segmentation.tooltips.transaction.rent.label')} </span>
        <span className={`font-body-medium-regular`}>{t('segmentation.tooltips.transaction.rent.description')}</span>
      </div>
      <div className={'grid-item'}>
        <span className={`font-body-medium-bold`}>{t('segmentation.tooltips.transaction.sell.label')} </span>
        <span className={`font-body-medium-regular`}>{t('segmentation.tooltips.transaction.sell.description')}</span>
      </div>
      <div className={'grid-item'}>
        <span className={`font-body-medium-bold`}>
          {t('segmentation.tooltips.transaction.shortTermAccommodation.label')}{' '}
        </span>
        <span className={`font-body-medium-regular`}>
          {t('segmentation.tooltips.transaction.shortTermAccommodation.description')}
        </span>
      </div>
    </div>
  )
}
